module.exports = __webpack_public_path__ + "static/media/street-name.f919c286.svg";